module.exports = __webpack_public_path__ + "img/bowl_of_lemon_drops.413318b1.jpg";